import { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ScrollText, ChevronLeft, ChevronRight } from "lucide-react";

const PAGE_SIZE = 25;

export default function AuditLog() {
  const [data, setData] = useState({ items: [], total: 0, page: 1, pages: 1 });
  const load = useCallback((page = 1) => {
    api.get(`/audit-logs?page=${page}&page_size=${PAGE_SIZE}`)
      .then((r) => setData(r.data)).catch(() => {});
  }, []);
  useEffect(() => { load(1); }, [load]);

  const { items, total, page, pages } = data;

  return (
    <div className="space-y-6 animate-fade-up">
      <div>
        <h1 className="font-heading text-3xl font-bold tracking-tight">Audit Trail</h1>
        <p className="text-muted-foreground">Every consequential action is logged for accountability &amp; compliance.</p>
      </div>
      <Card className="divide-y divide-border" data-testid="audit-list">
        {items.map((l) => (
          <div key={l.id} className="p-4 flex items-start gap-3" data-testid={`audit-${l.id}`}>
            <div className="h-8 w-8 rounded-md bg-secondary flex items-center justify-center brand-text shrink-0"><ScrollText className="h-4 w-4" /></div>
            <div className="min-w-0 flex-1">
              <p className="text-sm"><b>{l.actor_name}</b> · <span className="font-mono text-xs">{l.action}</span> · {l.target}</p>
              {l.detail && <p className="text-xs text-muted-foreground">{l.detail}</p>}
            </div>
            <span className="text-xs text-muted-foreground whitespace-nowrap">{new Date(l.timestamp).toLocaleString()}</span>
          </div>
        ))}
        {items.length === 0 && <p className="p-4 text-muted-foreground text-sm">No activity recorded yet.</p>}
      </Card>

      {pages > 1 && (
        <div className="flex items-center justify-between" data-testid="audit-pagination">
          <p className="text-xs text-muted-foreground">Page {page} of {pages} · {total} entries</p>
          <div className="flex gap-2">
            <Button data-testid="audit-prev" variant="outline" size="sm" disabled={page <= 1} onClick={() => load(page - 1)}><ChevronLeft className="h-4 w-4 mr-1" />Previous</Button>
            <Button data-testid="audit-next" variant="outline" size="sm" disabled={page >= pages} onClick={() => load(page + 1)}>Next<ChevronRight className="h-4 w-4 ml-1" /></Button>
          </div>
        </div>
      )}
    </div>
  );
}
